import { upperFirst, camelCase } from 'lodash';

var styles = {"alignLeft":"_5-Mre","textWrapNowrap":"BEuLG","alignRight":"d9Ka4","alignCenter":"UdXMv","sizeFullWidth":"NFNZN","renderedInTable":"a0drX","sizeOriginal":"bV3X-","sizeContent":"zPQnN","sizeSmall":"ODfhc","sizeSmallCenter":"Mni74","flex":"y8OTw","atomic":"vstK1","anchor":"_4g-qG","embed":"vt6tp","horizontalScrollbar":"Rq0gB","pluginContainerMobile":"SD-dM"};

const getContainerData = (node) => {
  var _a;
  const data = `${camelCase(node.type)}Data`;
  return (_a = node == null ? void 0 : node[data]) == null ? void 0 : _a.containerData;
};
const getAlignmentClassName = (containerData = {}) => {
  const { alignment } = containerData;
  if (!alignment) {
    return "";
  }
  const key = `align${upperFirst(alignment.toLowerCase())}`;
  return styles[key];
};
const getSizeClassName = (containerData) => {
  const { width } = containerData;
  const { size } = width || {};
  if (!size) {
    return "";
  }
  const key = `size${upperFirst(camelCase(size.toLowerCase()))}`;
  return styles[key];
};
const getTextWrapClassName = (containerData = {}) => {
  const { textWrap } = containerData;
  if (textWrap) {
    return "";
  }
  return styles.textWrapNowrap;
};
const alignmentClassName = (node) => {
  return getAlignmentClassName(getContainerData(node));
};
const sizeClassName = (node) => {
  return getSizeClassName(getContainerData(node) || {});
};
const textWrapClassName = (node) => {
  return getTextWrapClassName(getContainerData(node));
};

export { getSizeClassName as a, getTextWrapClassName as b, alignmentClassName as c, sizeClassName as d, getAlignmentClassName as g, styles as s, textWrapClassName as t };
//# sourceMappingURL=getClassNames-68659c0f.js.map
